export default class StorageService {
  get(key: string): any {
    return localStorage.getItem(key);
  }

  set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  delete(key: string) {
    localStorage.removeItem(key);
  }

  /* eslint-disable @typescript-eslint/no-explicit-any*/
  getUser(): any {
    let aux;
    const data = this.get("user");
    if (data) aux = JSON.parse(data);
    return aux;
  }
}
